module.exports = __webpack_public_path__ + "static/media/weighing-machine.4f535516.svg";